import { IWorkspaceDB } from '../../../db/interface';
import { IProgressPromise, IProgressPromiseGenerator } from '../../../interface/promise';
import type { INSTANTIATOR_INTERFACES } from '@monofe/apiservice/model/interface/instantiator';
import { SourceApiDataArray, SourceApiRecord } from './interfaces';

function _promise<Interface extends keyof INSTANTIATOR_INTERFACES>(
    db: IWorkspaceDB,
    entityName: Interface,
    items: SourceApiDataArray<Interface>,
): Promise<void> {
    let promise = Promise.resolve();

    if (entityName) {
        promise = db.table(entityName).bulkAddOrUpdate(items as any);
    } else {
        console.error(`Unable to find table name for entity: ${entityName}`);
    }

    return promise;
}

function update(
    promiser: IProgressPromiseGenerator,
    db: IWorkspaceDB,
    source: Partial<SourceApiRecord>,
): IProgressPromise<void> {
    return promiser.promise(async function (resolve, reject, progress) {
        try {
            const patchPaths = Object.keys(source) as Array<keyof INSTANTIATOR_INTERFACES>;
            const progressPerPath = 1.0 / patchPaths.length;

            for (let i = 0; i < patchPaths.length; i++) {
                const patchPath = patchPaths[i];
                const items = source[patchPath];

                if (!items) {
                    continue; /* no data */
                }

                const promise = _promise(db, patchPath, items);

                await promise;

                progress(i * progressPerPath);
            }

            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

export default update;
